import React from 'react';
import { Links } from '@/features/b2b/resources/components/marketing-toolkit/request-toolkit/Links';

import { ResponsivePicture } from '@/components/ResponsivePicture';
import toolkitFormMobImg from '@public/img/adviser/resources/marketing-toolkit/toolkit-form-mob.webp';
import toolkitFormTabImg from '@public/img/adviser/resources/marketing-toolkit/toolkit-form-tab.webp';
import toolkitFormImg from '@public/img/adviser/resources/marketing-toolkit/toolkit-form.webp';
export const Resources = () => {
  return (
    <div className="container mx-auto pb-10 md:pb-12 lg:pb-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center lg:items-stretch gap-12 xl:gap-20">
        <Links />
        <ResponsivePicture
          mobile={toolkitFormMobImg}
          tablet={toolkitFormTabImg}
          desktop={toolkitFormImg}
          alt="Woman in glasses taking notes while working on a laptop"
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="rounded-2xl w-full lg:h-full object-cover"
          pictureClassName="block w-full lg:h-full"
        />
      </div>
    </div>
  );
};
